import { gql } from '@apollo/client';

export const CheckProcessingStatus = gql`
    subscription checkProcessingStatus($agentId: ID!) {
        checkProcessingStatus(agentId: $agentId)
    }
`;
